import React from "react";

export function TabsPanel({ children, activeTab }) {
  const tabs = React.Children.toArray(children);
  const activeContent = tabs.find(tab => tab.props.value === activeTab);

  return (
    <div className="mt-4">
      {activeContent}
    </div>
  );
}

export function TabPanel({ children, value }) {
  return (
    <div role="tabpanel" id={`tabpanel-${value}`} aria-labelledby={`tab-${value}`}>
      {children}
    </div>
  );
}